(function ($) {

    $(document).ready(function () {
        var obj = {
            'list-hoover-report': 'edit-mailchimp-lists-mailchimp-21b1edff3c-subscribe',
            'list-defining': 'edit-mailchimp-lists-mailchimp-31433b2ef9-subscribe',
            'list-caravan': 'edit-mailchimp-lists-mailchimp-d790910c21-subscribe',
            'list-hoover-digest': 'edit-mailchimp-lists-mailchimp-db86d9b656-subscribe',
            'list-california': 'edit-mailchimp-lists-mailchimp-7c523ba4de-subscribe',
            'list-event-notification': 'edit-mailchimp-lists-mailchimp-c0f9950213-subscribe',
            'list-strategika': 'edit-mailchimp-lists-mailchimp-ec368bf78b-subscribe',
            'list-monthly-newsletter': 'edit-mailchimp-lists-mailchimp-cf6b4ee2b2-subscribe',
            'list-tune-in': 'edit-mailchimp-lists-mailchimp-c52c8fa9e5-subscribe',
            'list-tower': 'edit-mailchimp-lists-mailchimp-9827b1d4e3-subscribe',
            'list-uncommon-knowledge': 'edit-mailchimp-lists-mailchimp-610ce6eca4-subscribe',
            'list-hoover-monthly-podblast': 'edit-mailchimp-lists-mailchimp-b1eb93251b-subscribe',
            'list-hoover-weekend-review': 'edit-mailchimp-lists-mailchimp-b4742ebbe4-subscribe',
            'list-hoover-monthly-economy': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-7093ab25e6-17883c86dc',
            'list-hoover-monthly-education': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-7093ab25e6-9e85ca01f0',
            'list-hoover-monthly-security': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-7093ab25e6-43084d3ca7',
            'list-hoover-monthly-election': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-7093ab25e6-3225ceb986',
            'list-hoover-monthly-briefings': 'edit-mailchimp-lists-mailchimp-21b1edff3c-interest-groups-458d5a14a0-f7849d50cc',
            'list-library-archive' : 'edit-mailchimp-lists-mailchimp-198e0bd348-subscribe--2'
        }

        if ($('.newsletter-grid').length > 0) {
            $(".newsletter-grid .cards-wrap .col-four .content-wrap h6").dotdotdot({
                height: 81,
                fallbackToLetter: true,
                watch: true,
            });
            $(".newsletter-grid .cards-wrap .col-four .content-wrap p").dotdotdot({
                height: 105,
                fallbackToLetter: true,
                watch: true,
            });
            $('.newsletter-grid .grid-wrapper .three-col').matchHeight();
            $('.newsletter-grid .cards-wrap .col-four').matchHeight();
            if ($(window).width() < 1399) {
                $('.newsletter-grid .daily-report-wrapper .grid-wrapper .three-col').matchHeight();
            }

            $('.newsletter-grid .form-group input').removeAttr("disabled");

            //code for click to select all checkboxes
            $('.newsletter-grid .form-group input#subscribe').on('click', function () {
                if (this.checked) {
                    $(".newsletter-grid .daily-report-wrapper input").each(function () {
                        this.checked = true;
                        $(this).parents('.daily-report-wrapper').find('.three-col').addClass('show-border');
                    })
                } else {
                    $(".newsletter-grid .daily-report-wrapper input").each(function () {
                        this.checked = false;
                        $(this).parents('.daily-report-wrapper').find('.three-col').removeClass('show-border');
                    })
                }

            });

            ////code for click to select and de-select individual and de-select subscribe all checkbox
            $('.newsletter-grid .three-col .content-wrap > .form-group input').on('click', function () {
                if ($(this).is(":checked")) {
                    var isAllChecked = 0;
                    $(".newsletter-grid .daily-report-wrapper .grid-wrapper input").each(function () {
                        if (!this.checked)
                            isAllChecked = 1;
                    });
                    if (isAllChecked === 0) {
                        $(".newsletter-grid .form-group input#subscribe").prop("checked", true);
                    }
                } else {
                    $(".newsletter-grid .form-group input#subscribe").prop("checked", false);
                }
                if ($(this).parents('.three-col').hasClass('show-border')) {
                    $(this).parents('.three-col').removeClass('show-border');
                }
                else {
                    $(this).parents('.three-col').addClass('show-border');
                }
            });


            $('.newsletter-grid .three-col .content-wrap #list-hoover-monthly-briefings').on('click', function () {
                if ($(this).prop('checked') === false) {
                    // HDR monthly child non selection 
                    let monthlyChilds = $(this).parent().closest('.content-wrap').find('ul input');
                    monthlyChilds.each(function(key, val) {
                        let childID = $(this).attr('id');
                        // let selector = '[id^="' + obj[childID] + '"]';
                        // $(selector).prop('checked', false);
                        let hdrElem = $(`input[data-drupal-selector="${obj[childID]}"]`);
                        if (hdrElem.is(':checked')) {
                            hdrElem.trigger('click');
                        }
                    });

                    $('.newsletter-grid .daily-report-wrapper .grid-wrapper .three-col .content-wrap ul li .form-group input').prop('checked', false);
                    $(".newsletter-grid .daily-report-wrapper .grid-wrapper input").each(function () {
                        if (!this.checked) {
                            $(".newsletter-grid .form-group input#subscribe").prop("checked", false);
                            return false;
                        }
                        else {
                            $(".newsletter-grid .form-group input#subscribe").prop("checked", true);
                        }
                    });

                    // Root HDR checked on monthly child false
                    let HdrChildPos = false;
                    let subItems = $('.sub-hoover-re');
                    subItems.each(function() {
                        let subItemCheck = $(this).prop('checked');
                        if (subItemCheck) {
                            HdrChildPos = true;    
                            return false;
                        }
                    });
                    if (!HdrChildPos) {
                        $('#list-hoover-report').prop('checked', false);
                        let hdrElem = $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`);
                        if (hdrElem.is(':checked')) {
                            hdrElem.trigger('click');
                        }
                    }
                }
                else {
                    // HDR monthly child selection 
                    $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`).trigger('click');
                    let monthlyChilds = $(this).parent().closest('.content-wrap').find('ul input');
                    monthlyChilds.each(function(key, val) {
                        let childID = $(this).attr('id');
                        // let selector = '[id^="' + obj[childID] + '"]';
                        // $(selector).trigger('click');
                        $(`input[data-drupal-selector="${obj[childID]}"]`).trigger('click');
                    });

                    $('.newsletter-grid .daily-report-wrapper .grid-wrapper .three-col .content-wrap ul li .form-group input').prop('checked', true);
                    var len_check = $(".newsletter-grid .daily-report-wrapper .grid-wrapper input:checked").length;
                    var tot_len = $(".newsletter-grid .daily-report-wrapper .grid-wrapper input").length;
                    if ($('.newsletter-grid .three-col .content-wrap #list-hoover-monthly-briefings').is(':checked')) {
                        if (tot_len === len_check) {
                            $(".newsletter-grid .form-group input#subscribe").prop("checked", true);
                        }
                        else {
                            $(".newsletter-grid .form-group input#subscribe").prop("checked", false);
                        }
                    }
                    else {
                        $(".newsletter-grid .form-group input#subscribe").prop("checked", false);
                    }

                    // Root HDR checked on monthly child true
                    let subItems = $('.sub-hoover-re');
                    subItems.each(function() {
                        let subItemCheck = $(this).prop('checked');
                        if (subItemCheck) {
                            $('#list-hoover-report').prop('checked', true);
                            // $('[id^="' + obj['list-hoover-report'] + '"]').trigger('click');
                            // $('[id^="' + obj['list-hoover-report'] + '"]').prop('checked', true);
                            let hdrElem = $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`);
                            if (!hdrElem.is(':checked')) {
                                hdrElem.trigger('click');
                            }
                            return false;
                        }
                    });
                }
            });

            $('.newsletter-grid .three-col .content-wrap #list-hoover-weekend-review').on('click', function () {
                if ($(this).prop('checked') === true) {
                    // Root HDR checked on monthly child true
                    // let subItems = $('.sub-hoover-re');
                    // subItems.each(function() {  
                    //     let subItemCheck = $(this).prop('checked');
                    //     if (subItemCheck) {
                    //         $('#list-hoover-report').prop('checked', true);
                    //         $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`).trigger('click');
                    //         return false;
                    //     }
                    // });
                    let hdrElem = $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`);
                    $('#list-hoover-report').prop('checked', true);
                    if (!hdrElem.is(':checked')) {
                        hdrElem.trigger('click');
                    }
                } else {
                    // Root HDR checked on monthly child false
                    let HdrChildPos = false;
                    let subItems = $('.sub-hoover-re');
                    subItems.each(function() {
                        let subItemCheck = $(this).prop('checked');
                        if (subItemCheck) {
                            HdrChildPos = true;    
                            return false;
                        }
                    });
                    if (!HdrChildPos) {
                        $('#list-hoover-report').prop('checked', false);
                        let hdrElem = $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`);
                        if (hdrElem.is(':checked')) {
                            hdrElem.trigger('click');
                        }
                    }
                }
            });

            $('.newsletter-grid .three-col .content-wrap .monthly-sub-list').on('click', function () {
                if ($(this).prop('checked') === true) {
                    // Root HDR checked on monthly child true
                    let subItems = $('.sub-hoover-re');
                    subItems.each(function() {
                        let subItemCheck = $(this).prop('checked');
                        if (subItemCheck) {
                            $('#list-hoover-report').prop('checked', true);
                            let hdrElem = $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`);
                            if (!hdrElem.is(':checked')) {
                                hdrElem.trigger('click');
                            }
                            return false;
                        }
                    });
                } else {
                    // Root HDR checked on monthly child false
                    let HdrChildPos = false;
                    let subItems = $('.sub-hoover-re');
                    subItems.each(function() {
                        let subItemCheck = $(this).prop('checked');
                        if (subItemCheck) {
                            HdrChildPos = true;    
                            return false;
                        }
                    });
                    if (!HdrChildPos) {
                        $('#list-hoover-report').prop('checked', false);
                        let hdrElem = $(`input[data-drupal-selector="${obj['list-hoover-report']}"]`);
                        if (hdrElem.is(':checked')) {
                            hdrElem.trigger('click');
                        }
                    }
                }
            });

            $('.newsletter-grid .cards-wrap .col-four input').on('click', function () {
                if (this.checked) {
                    $(this).parents('.col-four').addClass('show-border');
                }
                else {
                    $(this).parents('.col-four').removeClass('show-border');
                }
            });

            $('.newsletter-grid .daily-report .hoover-report #list-hoover-report').on('click', function () {
                var len_check = $(".newsletter-grid .daily-report-wrapper .grid-wrapper input:checked").length;
                var tot_len = $(".newsletter-grid .daily-report-wrapper .grid-wrapper input").length;
                if ($('.newsletter-grid .daily-report .hoover-report #list-hoover-report').is(':checked')) {
                    if (tot_len === len_check) {
                        $(".newsletter-grid .form-group input#subscribe").prop("checked", true);
                    }
                    else {
                        $(".newsletter-grid .form-group input#subscribe").prop("checked", false);
                    }
                }
                else {
                    $(".newsletter-grid .form-group input#subscribe").prop("checked", false);
                    $(this).closest('.daily-report-wrapper').find('.sub-hoover-re').closest('.three-col').removeClass('show-border');
                }
            });
        }
    });

})(jQuery);